/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import Loader from '../Loader/Loader';
import api from '../../api';
import WithRouter from '../Extensions/WithRouter';

class DeleteLDAPModal extends Component {
  constructor(props) {
    super(props);
    const { translate } = props;
    this.modalHeader = translate('modal.title.attention');
    this.modalBody = translate('modal.message.delete_ldap');
    this.modalSubBody = translate('modal.message.delete_ldap_sub');
    this.state = {
      isOpenMDL: props.isOpenMDL,
      selectedIds: props.selectedIds,
      error: false,
      isLoading: false,
    };
    this.closeDeleteLDAPModal = this.closeDeleteLDAPModal.bind(this);
    this.handleDeleteLDAP = this.handleDeleteLDAP.bind(this);
  }

  componentDidMount() {}

componentDidUpdate(prevProps) {
    const { isOpenMDL, selectedIds, translate } = this.props;

    if (prevProps.isOpenMDL !== isOpenMDL) {
      this.setState({ isOpenMDL });

      if (isOpenMDL) {
        this.modalHeader = translate('modal.title.attention');
        this.modalBody = translate('modal.message.delete_ldap');
        this.modalSubBody = translate('modal.message.delete_ldap_sub');

        this.setState({
          selectedIds,
          error: false,
          isLoading: false,
        });
      }
    }
  }

  handleDeleteLDAP() {
    const { selectedIds } = this.state;
    const { translate } = this.props;
    const obj = {
      ldap_ids: selectedIds,
    };

    this.setState({
      isLoading: true,
    }, () => {
      api
        .deleteLDAP(obj)
        .then(() => {
          this.setState({
            isLoading: false,
          });
          this.props.handleDeleteCallback();
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          if (o.error_description) {
            this.modalBody = o.error_description;
            this.modalSubBody = null;
            this.setState({
              error: true,
              isLoading: false,
            });
          } else if (o.error === '422-752') {
            this.modalBody = translate('modal.error.invalid_access');
            this.modalSubBody = null;
            this.setState({
              error: true,
              isLoading: false,
            });
          } else {
            this.modalBody = translate('modal.error.unknow_error');
            this.modalSubBody = null;
            this.setState({
              error: true,
              isLoading: false,
            });
          }
        });
    });
  }

  closeDeleteLDAPModal(e) {
    if (e.target.className === 'right_button') {
      return;
    }
    this.setState({
      isOpenMDL: false,
    });
    this.props.closeModal();
  }

  render() {
    const { error, isLoading, isOpenMDL } = this.state;
    const { translate } = this.props;

    return (
      <Modal open={isOpenMDL} onClose={this.closeDeleteLDAPModal}>
        {
          isLoading ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">
                    {this.modalBody}
                  </p>
                  {
                    !error ? (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    ) : null
                  }
                  {
                    !error ? (
                      <div className="button_wrap">
                        <a onClick={this.closeDeleteLDAPModal} className="left_button">
                          {translate('modal.button.cancel')}
                        </a>
                        <a
                          onClick={this.handleDeleteLDAP}
                          className="right_button"
                        >
                          {translate('modal.button.delete')}
                        </a>
                      </div>
                    ) : (
                      <div className="button_wrap">
                        <a
                          onClick={this.closeDeleteLDAPModal}
                          className="center_button"
                        >
                          {translate('modal.button.ok')}
                        </a>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          )
        }
      </Modal>
    );
  }
}

export default WithRouter(DeleteLDAPModal);
